/**
 * Stock Video Actions API
 *
 * Save/unsave stock videos per namespace and fetch saved IDs or lists.
 */
import { get, post, del } from '../core';

// Save a stock video to a namespace
export const saveStockVideo = async (stockVideoId, namespaceId) => {
  try {
    if (!namespaceId) {
      throw new Error('Namespace ID is required to save stock videos');
    }
    
    const response = await post(`/stockVideos/save/${stockVideoId}?namespaceId=${encodeURIComponent(namespaceId)}`, {});
    return response.data;
  } catch (error) {
    console.error('Error saving stock video:', error);
    throw error;
  }
};

// Unsave a stock video from a namespace
export const unsaveStockVideo = async (stockVideoId, namespaceId) => {
  try {
    if (!namespaceId) {
      throw new Error('Namespace ID is required to unsave stock videos');
    }
    
    const response = await del(`/stockVideos/save/${stockVideoId}?namespaceId=${encodeURIComponent(namespaceId)}`);
    return response.data;
  } catch (error) {
    console.error('Error unsaving stock video:', error);
    throw error;
  }
};

// Get saved stock video IDs for a specific namespace
export const getSavedStockVideoIds = async (namespaceId) => {
  try {
    if (!namespaceId) {
      console.warn('No namespace ID provided, cannot fetch saved stock videos');
      return [];
    }
    
    // Use the namespaces endpoint to get namespace details including savedStockVideos
    const namespaceData = await get(`/namespaces/${namespaceId}`);
    
    // Extract savedStockVideos from the namespace data
    if (namespaceData && Array.isArray(namespaceData.savedStockVideos)) {
      return namespaceData.savedStockVideos;
    }
    
    // In case the savedStockVideos array doesn't exist
    return [];
  } catch (error) {
    // If endpoint doesn't exist (404), return empty array
    if (error.message?.includes('404') || error.status === 404) {
      console.log('Stock videos saved endpoint not yet implemented, returning empty array');
      return [];
    }
    console.error('Error getting saved stock video IDs:', error);
    return []; // Return empty array on error to avoid breaking the UI
  }
};

// Get saved stock videos with full details
export const getSavedStockVideos = async (namespaceId, options = {}) => {
  try {
    if (!namespaceId) {
      throw new Error('Namespace ID is required to get saved stock videos');
    }
    
    const { page = 1, limit = 20, sortBy = 'newest' } = options;
    const response = await get('/stockVideos/saved/details', {
      params: { namespaceId, page, limit, sortBy }
    });
    return response.data;
  } catch (error) {
    console.error('Error getting saved stock videos:', error);
    throw error;
  }
}; 